import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.scheduling-project')
  .factory('$schedulingProject', schedulingProjectObjectFactory);

function schedulingProjectObjectFactory($bringozFactory: $bringozFactory,
                                        SchedulingProjectAPI: BringozApi,
                               Schedule_DS: DataStoreConfig) {

  function $schedulingProject(id: string) {
    return $bringozFactory(id, SchedulingProjectAPI, Schedule_DS)
  }

  return $schedulingProject
}
